import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeaderSelectService {

  idEmpresa: string;
  idUsuario: string;
  idInstituto: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  //SERVICIOS CERTIFICAR
  getStatusIdioma(anio: any){
    let datos: any = {productoId: anio,	leaderSelect: 1};
    console.log(this.idEmpresa);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  getLideresCerAsociados(idAsociado: any,productoId:any, search: any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getLideresCerAsoci + idAsociado+'/'+productoId+'/'+search);
  }


  guardaStatusLeaderSelect(datos){
    // let datos: any = {fechaCertificar: anio,	idiomas: 3};
    console.log(datos);

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  saveLideresBackFiltrado(asociadoId:any,productoId: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.leaderGo.saveLeadersBack+asociadoId+'/'+ productoId,{});
  }



  getLeadersActionGoSql(empresaId:any,idAsociado: any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.actionGo.getLideresActionGo +empresaId+'/'+idAsociado);
  }
  enviarEmailLeadersGo(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.leaderGo.sendEmailLeaderGo +this.idEmpresa,datos);
  }


}
